'use client';

import MuxPlayer from '@mux/mux-player-react';
import Link from 'next/link';
import React, { useState } from 'react';
import { GoPlus } from 'react-icons/go';

interface CardProps {
  desktopImageSrc: string;
  mobileImageSrc: string;
  title: string;
  baseLink: string;
  enableMuxVideo: boolean;
  muxPlaybackId: any;
}

const ProjectCard: React.FC<CardProps> = ({
  desktopImageSrc,
  mobileImageSrc,
  title,
  baseLink,
  enableMuxVideo,
  muxPlaybackId,
}) => {
  const [mousePos, setMousePos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    setIsHovered(true);
  };
  return (
    <div className="mb-16 project-box w-50 ">
      <div
        className="relative group overflow-hidden"
        onMouseMove={handleMouseMove}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Link href={baseLink} scroll={false} className="block">
          {enableMuxVideo && muxPlaybackId ? (
            <MuxPlayer
              playbackId={muxPlaybackId}
              autoPlay
              muted
              loop
              playsInline
              streamType="on-demand"
              style={{ width: '100%' }}
            />
          ) : (
            <picture>
              <source srcSet={desktopImageSrc} media="(min-width: 768px)" />
              <img
                src={mobileImageSrc && desktopImageSrc}
                alt={title}
                className="w-full h-full object-cover aspect-[3/4]"
              />
            </picture>
          )}
        </Link>
        {/* Overlay "View More" on hover */}

        <div
          className={`absolute pointer-events-none flex items-center justify-center transition-opacity duration-300 cursor-pointer font-dm-mono ${
            isHovered ? 'opacity-100' : 'opacity-0 hidden'
          }`}
          style={{
            left: `${mousePos.x}px`,
            top: `${mousePos.y}px`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <span className="text-[#E5E1D5] text-[12px] tracking-widest uppercase flex text-nowrap items-center">
            View More [ <GoPlus /> ]
          </span>
        </div>
      </div>
      <div className="mt-[12px] text-[#2B332A] text-base font-light">
        <div className="text-[16px] font-light text-[#2a3329] leading-[18px]">
          <p>{title}</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
